import React from 'react';
import styles from './PageHeader.module.css';
import { Link } from 'gatsby'

const PageHeader = ({headerClass}) => {
    const search = typeof window !== 'undefined' ? window.location.search : "";
    const queryParams = new URLSearchParams(search);
    const backRef = queryParams.get('backRef')
    let styleClass = null
    if (headerClass === "theme-report-landing") {
        styleClass = styles.ThemeReportLanding
    }
    if (headerClass === "theme-report") {
        styleClass = styles.ThemeReport
    }
    const backLink = backRef ? <Link to={backRef}>back</Link> : <Link to="/home/professional/">annual home</Link>
    return (
        <header className={[styles.BackToAnnual, "back-to-annual", styleClass].join(" ")}>
            {backLink}
            <h1>D&AD Annual 2020</h1>
        </header>
    )
}

export default PageHeader;